<template>
  <div class="page-wrap"></div>
</template>

<script>
export default {
  name: 'SettingsView',
  mounted() {
    this.$router.replace({ path: '/profile', query: { tab: 'settings' } });
  },
};
</script>